import smoothscroll from 'smoothscroll-polyfill'
import Quill from '@capaj/quill'

smoothscroll.polyfill()
window.Quill = Quill // TODO global Quill is needed for removal of images. It would be nice to fork Quill and fix this by using a local import in the image resize plugin

declare global {
  interface Window {
    Quill: any
    ga: any
    __h: any
    gapi: any
    google: any
  }
}
